import { render, staticRenderFns } from "./CrudLabel.vue?vue&type=template&id=e8b15af4"
import script from "./CrudLabel.vue?vue&type=script&lang=js"
export * from "./CrudLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8b15af4')) {
      api.createRecord('e8b15af4', component.options)
    } else {
      api.reload('e8b15af4', component.options)
    }
    module.hot.accept("./CrudLabel.vue?vue&type=template&id=e8b15af4", function () {
      api.rerender('e8b15af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/crud-components/CrudLabel.vue"
export default component.exports